import { Link } from 'react-router-dom'

import { Button } from '@/components/button'
import { PsychiatryIcon } from '@/components/icons/psychiatry'

export function PreservationBanner() {
  return (
    <div className="h-full bg-preservationBanner bg-cover">
      <div className="flex h-full flex-col items-center justify-center gap-5 px-5 py-5 xl:w-1/2 xl:items-start xl:justify-start xl:px-40 xl:py-20">
        <span className="flex items-center gap-2 rounded-lg bg-bios-100 p-2 text-center font-bold text-bios-secondary xl:text-start">
          <PsychiatryIcon />
          Preservação
        </span>
        <h1 className="text-center text-2xl font-bold text-white md:text-4xl xl:text-start">
          Provemos os meios para proteger os 6 biomas brasileiros
        </h1>
        <div className="flex flex-1 items-center text-center xl:text-start">
          <p className="my-auto text-lg text-white">
            Realizamos a captação e a distribuição de capital para fomento da
            conservação ambiental nos principais biomas do Brasil.
          </p>
        </div>
        <Button
          variant="outline"
          className="border border-bios-primary bg-transparent font-normal uppercase text-white"
          asChild
        >
          <Link to="/preservation">Saiba mais</Link>
        </Button>
      </div>
    </div>
  )
}
